<template>
  <div class="machine-container machine-com">
    <div>
      <h1 class="">{{ $t('machines') }}</h1>
      <div class="search-add-sec ">
        <input type="text" :placeholder="$t('name')" @input="filterMachine" />
        <img width="50" :src="fit20.storageBaseUrl + '/static/icons/%2B.png'" @click.stop.prevent="editMachine()" />
      </div>
    </div>
    <div class="machines">
      <div class="machine-card" v-for="machine in filteredMachines" :key="machine.id"
        @click.stop.prevent="editMachine(machine.id)">
        <div>
          <img :src="fit20.storageBaseUrl + '/machine/' + machine.name + '.svg'" alt="">
        </div>
        <a href="#admin_machine" :id="machine.id">
          <div>{{ machine.brand }}</div>
          <div>{{ machine.name }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Machines',
  components: {},
  props: ["fit20", "selectTab", "admin_fit20"],
  data() {
    return {
      filteredMachines: [],
      inputValue: ''
    };
  },
  methods: {
    async editMachine(id) {
      // console.log("edit machine");
      if (id) {
        const res = await fetch(this.fit20.baseUrl + "/api/machines/" + id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
        this.admin_fit20.machine = await res.json();
      } else {
        this.admin_fit20.machine = {
          id: "new_machine",
          adjustable: [{
            name: "",
            values: ""
          }],
          adjustableValues: []
        }
      }
      this.selectTab('#admin_machine');
    },
    filterMachine(event) {
      this.inputValue = event;
      let searchWord = event.target.value.toLowerCase().trim()
      if (searchWord.length > 0) {
        this.filteredMachines =
          this.fit20.machines.filter(machine => machine.name.toLowerCase().includes(searchWord) ||
            machine.brand.toLowerCase().includes(searchWord));
      } else {
        this.filteredMachines = [...this.fit20.machines]
      }
    },
  },
  mounted: function () {
    if (this.inputValue && this.inputValue.length > 0) {
      this.filterMachine(this.inputValue);
    }
  },
  created: async function () {
    // const getAllMachines = await fetch(this.fit20.baseUrl + "/api/machines/");
    // this.admin_fit20.machines = await getAllMachines.json();
    if (this.inputValue && this.inputValue.length > 0) {
      this.filterMachine(this.inputValue);
    }
  },
  watch: {
    'admin_fit20.machines': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        console.log("machines watch");
        console.log(newVal);
        if (!this.inputValue) {
          this.filteredMachines = [...newVal];
        }
      }
    }
  }
};
</script>

<style>
.machine-com h1 {
  color: var(--fit20-blue);
}

.machine-com.machine-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.machine-com .search-add-sec {
  display: flex;
  justify-content: space-between;
}

.machine-com .search-add-sec img {
  width: 50px;
  min-width: 0px;
  min-height: 0px;
}

.machine-com .machine-container input {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  padding: 7px 5px;
  width: 40%;
}

.machine-com .machines {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: calc(100% - 100px);
  /* Adjust as needed */
  overflow: auto;
  margin-top: 10px;
}

.machine-com .machine-card {
  display: flex;
  margin: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  width: calc(100% / 3 - 20px);
  min-height: 70px;
  border-radius: 10px;
  padding-top: 5px;
  padding-left: 5px;
}

.machine-com .machine-card a {
  display: inline-block;
  width: 100%;
  height: 100%;
  margin-left: 10px;
}

.machine-com img {
  width: 35%;
  max-width: 110px;
  min-width: 70px;
  min-height: 70px;
}
</style>
